export function hasMessageOrAttachment(message: string, files: File[]) {
  return message.trim().length > 0 || files.length > 0;
}
